import { render, staticRenderFns } from "./NewAdminData.vue?vue&type=template&id=20b796da&scoped=true&"
import script from "./NewAdminData.vue?vue&type=script&lang=js&"
export * from "./NewAdminData.vue?vue&type=script&lang=js&"
import style0 from "./NewAdminData.vue?vue&type=style&index=0&id=20b796da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b796da",
  null
  
)

export default component.exports